import styled from "styled-components";

export const DftOptWrapper = styled.div.attrs({
  className: "w-full flex flex-col items-end ",
})``;
